<template>
  <div v-if="!isHomePage" class="custom-navbar" :class="isOtherNavbar ? 'navbar-central' : ''">
    <VanNavBar
      :title="title"
      :fixed="true"
      :left-arrow="showLeftArrow"
      placeholder
      clickable
      @click-left="onBack"
    >
      <template v-if="isRecord" #right>
        <div class="record-img" @click="changePage">
          <img src="@/assets/record.png" />
        </div>
      </template>
    </VanNavBar>
  </div>
</template>

<script setup>
import { rootRouteList } from '@/config/routes'

const route = useRoute()
const router = useRouter()
const { t } = useI18n()

const isHomePage = computed(() =>
  ['Home', 'Activity', 'Profile', 'game-id', 'Saque', 'Registros', 'Games'].includes(route.name)
)
const isRecord = computed(() => ['WithdrawalHistory', 'DepositHistory'].includes(route.name))

const isOtherNavbar = computed(() => ['AccountCenter'].includes(route.name))
/**
 * Get page title
 * Located in src/locales/json
 */
const title = computed(() => {
  if (route.name) {
    return t(`navbar-index.navbar.${route.name}`)
  }

  return t('navbar-index.navbar.Undefined')
})

/**
 * Show the left arrow
 * If route name is in rootRouteList, hide left arrow
 */
const showLeftArrow = computed(() => {
  if (route.name && rootRouteList.includes(route.name)) {
    return false
  }

  return true
})

function onBack() {
  try {
    if (window.history.state.back) {
      history.back()
    } else {
      router.replace('/')
    }
  } catch (error) {
    window.location.href = '/'
  }
}

function changePage() {
  if (route.name == 'DepositHistory') {
    router.push({ name: 'WithdrawalHistory' })
  } else {
    router.back()
  }
}
</script>
<style lang="scss" scoped>
:deep(.van-nav-bar__title) {
  font-size: 15px;
}
.custom-navbar {
  :deep(.van-hairline--bottom:after) {
    border-width: 0 !important;
  }
}

.navbar-central {
  :deep(.van-nav-bar) {
    background: linear-gradient(to right, #49c755, #0f9957) !important;
  }
}
.record-img {
  width: 17.5px;
}
</style>
